import { render } from "./PFooter.vue?vue&type=template&id=940c208a&scoped=true"
import script from "./PFooter.vue?vue&type=script&lang=js"
export * from "./PFooter.vue?vue&type=script&lang=js"

import "./PFooter.vue?vue&type=style&index=0&id=940c208a&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940c208a"]])

export default __exports__